import { render, staticRenderFns } from "./CalendarPickerItem.vue?vue&type=template&id=5dc3b5ef&scoped=true&"
import script from "./CalendarPickerItem.vue?vue&type=script&lang=js&"
export * from "./CalendarPickerItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPickerItem.vue?vue&type=style&index=0&id=5dc3b5ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3b5ef",
  null
  
)

export default component.exports